/**
 * Patient display name resolver
 *
 * Prefers phone-verified names from auth, then `signedUpPatients` fields, with a
 * `"Patient"` fallback for Chatwoot and analytics identification.
 */

import type { SignedUpPatient } from '@physiofit-digital/physiofit_types';
import type { VerifiedPatientNamesFromAuth } from '../store/onboardingStore';

/**
 * Builds a single display name from verified auth names and/or the signed-up patient doc.
 *
 * @param {Object | undefined} signedUpPatient Current `signedUpPatients` document.
 * @param {Object | undefined} verifiedPatientNamesFromAuth Names from phone auth callable.
 * @return {string} Trimmed full name or `"Patient"`.
 */
export function resolvePatientDisplayName(
  signedUpPatient: SignedUpPatient | undefined,
  verifiedPatientNamesFromAuth: VerifiedPatientNamesFromAuth | undefined,
): string {
  const first = verifiedPatientNamesFromAuth?.firstName ?? signedUpPatient?.patientFirstName ?? '';
  const last = verifiedPatientNamesFromAuth?.lastName ?? signedUpPatient?.patientLastName ?? '';
  return [first, last].filter(Boolean).join(' ').trim() || 'Patient';
}
